import http from './httpClient';

export default {
  http
};
